<template>
  <div class="intro-section">
    <div class="content-wrapper">
      <div class="cover">
        <img :src="coverSrc" alt="漫画封面" class="cover-image" />
      </div>
      <div class="info">
        <h1 class="info-name">{{ comic.name }}</h1>
        <p class="info-author">{{ comic.authorName }}</p>
        <p class="info-volume-count">
          <AppIcon name="book" size="sm" class="info-row-icon" aria-label="卷数" />
          共 {{ comic.volTotal }} 卷
        </p>
        <p
          v-if="comic.comicThemeArray && comic.comicThemeArray.length > 0"
          class="info-themes"
        >
          <AppIcon name="tag" size="sm" class="info-row-icon" aria-hidden="true" />
          <template
            v-for="(theme, index) in comic.comicThemeArray"
            :key="theme.themeCode || index"
          >
            {{ theme.themeName || '' }}
            <span v-if="index !== comic.comicThemeArray.length - 1"> / </span>
          </template>
        </p>
        <p class="info-status">
          <AppIcon name="check" size="sm" class="info-row-icon" aria-label="连载状态" />
          {{ comic.serial }}
        </p>
        <div class="info-synop-block">
          <div class="comic-synop-wrapper">
            <p
              :ref="bindSynopRef"
              class="comic-synop info-synop"
              :class="{ expanded: isDescriptionExpanded }"
            >
              {{ comic.synop }}
            </p>
            <button
              v-if="shouldShowToggleButton"
              class="toggle-description-btn"
              @click.stop="toggleDescription"
              :title="isDescriptionExpanded ? '收起' : '展开'"
              :style="{ top: buttonTop + 'px' }"
            >
              <AppIcon
                :name="isDescriptionExpanded ? 'chevronUp' : 'chevronDown'"
                size="sm"
                aria-label=""
              />
            </button>
          </div>
        </div>
        <div class="intro-actions">
          <el-button type="primary" class="intro-btn-read" @click="goToReadOrContinue">
            <span class="intro-btn-read__icon-wrap" aria-hidden="true">
              <AppIcon name="play" size="sm" class="icon-left" />
            </span>
            {{ hasReadProgress() ? '继续观看' : '开始观看' }}
          </el-button>
          <el-button
            plain
            class="intro-btn-collect"
            :class="{ 'is-collected': isCollect }"
            @click="handleCollect"
          >
            <AppIcon
              name="heart"
              size="sm"
              class="icon-left"
              :variant="isCollect ? 'active' : 'default'"
              aria-label="收藏"
            />
            {{ buttonText }}
          </el-button>
          <el-button plain class="intro-btn-reward" @click="handleReward">
            <AppIcon name="gift" size="sm" class="icon-left" aria-label="打赏" />
            {{ rewardButtonText }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import AppIcon from '@/shared/components/AppIcon.vue'
import { getOssImageUrl } from '@/shared/utils/ossImage'

const props = defineProps({
  comic: { type: Object, required: true },
  synopRef: { type: Object, default: null },
  isDescriptionExpanded: { type: Boolean, default: false },
  buttonTop: { type: Number, default: 0 },
  shouldShowToggleButton: { type: Boolean, default: false },
  isCollect: { type: Boolean, default: false },
  buttonText: { type: String, default: '收藏' },
  rewardButtonText: { type: String, default: '打赏' },
  toggleDescription: { type: Function, required: true },
  goToReadOrContinue: { type: Function, required: true },
  hasReadProgress: { type: Function, required: true },
  handleCollect: { type: Function, required: true },
  handleReward: { type: Function, required: true },
})

const coverSrc = computed(() => getOssImageUrl(props.comic?.cover, 'detail'))

function bindSynopRef(el) {
  if (props.synopRef) {
    props.synopRef.value = el
  }
}
</script>
